import { Tooltip } from "@mui/material";

import Icon from "@musicfy/components/Icon";
import Slider from "@musicfy/components/Slider";

interface IPitchSliderProps {
  value: number;
  handleChange: (value: number) => void;
}

const PitchSlider = ({ value, handleChange }: IPitchSliderProps) => {
  return (
    <div className="p-5 flex lg:flex-row flex-col lg:items-center rounded-12 bg-white/2 border border-solid border-white/25">
      <Tooltip
        arrow
        title="Modify the frequency of the audio clip. Use this for correcting pitch or creating harmonies."
      >
        <div className="flex items-center gap-2 cursor-pointer">
          <Icon name="help" className="pb-[2px]" />
          <div className="whitespace-nowrap">Set Pitch:</div>
        </div>
      </Tooltip>
      <div className="w-full lg:ml-6 gap-6 flex items-center justify-center">
        <div>{value < 0 ? value : `-0`}</div>
        <Slider
          value={value}
          step={1}
          min={-12}
          max={12}
          size="small"
          onChange={(e, val) => {
            handleChange(val as number);
          }}
        />
        <div>{value > 0 ? `+${value}` : `+0`}</div>
      </div>
    </div>
  );
};

export default PitchSlider;
